// extracted by mini-css-extract-plugin
export default {"avatar":"Post_avatar__lT7DW","postblock":"Post_postblock__by2yU","post":"Post_post__SRvIO","borderblock":"Post_borderblock__iQjgM","likes":"Post_likes__XoCpc"};